const CardHoverIcons = () => {
  return (
    <div className="absolute hidden -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 group-hover:block gap-x-3" />
  );
};

export default CardHoverIcons;
